<template>
  <el-carousel trigger="click" height="520px" width="890px">
    <el-carousel-item v-for="(item,index) in list" :key="index">
      <img :src="item" class="swiper-img"/>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
        list: [
          'static/images/carousel/1.jpg',
          'static/images/carousel/2.jpg',
          'static/images/carousel/3.jpg',
          'static/images/carousel/4.jpg'
        ]
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/home/component/HomeSwiper.vue